<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <template>
    <v-layout row wrap>
      <v-form v-model="valid">
        <v-layout row wrap justify-end>
          <v-flex xs4 md2>
            <v-select
              v-if="meioSelecionado === 'gerencianetpix'"
              :items="filtros"
              item-text="title"
              label="Filtros"
              item-value="value"
              v-model="filtro"
            >
            </v-select>
          </v-flex>
          <v-flex xs4 md3>
            <v-select
              label="Selecione a adquirenre responsável"
              :items="pagamentosSecundarios"
              item-value="forma_pagamento.descricao"
              item-text="forma_pagamento.descricao"
              hide-details
              v-model="meioSelecionado"
            ></v-select>
          </v-flex>
          <v-flex xs3 md1>
            <v-select
              :items="options"
              item-text="title"
              item-value="value"
              v-model="selectOpcoes"
            >
            </v-select>
          </v-flex>
          <v-flex xs6 :md4="opcoes.custom" :md2="!opcoes.custom">
            <v-menu
              ref="menuDataInicial"
              v-model="menuDataInicial"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-if="opcoes.custom"
                  v-model="opcoes.intervalo_relatorio"
                  label="Dias"
                  multiple
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  prepend-icon="event"
                  required
                  clearable
                  v-on="on"
                ></v-combobox>
                <v-combobox
                  v-else-if="opcoes.dia"
                  v-model="opcoes.data_relatorio"
                  label="Dia"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="date = parseDate(opcoes.data_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else
                  v-model="opcoes.mes_relatorio"
                  label="Mes"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="month = parseDate(opcoes.mes_relatorio)"
                  prepend-icon="event"
                  required
                  clearable
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker v-show="opcoes.custom" multiple v-model="dates" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex shrink>
             <v-btn icon color="info" @click="function () {
              if (meioSelecionado === 'gerencianetpix') carregarRelatorio()
              else if (meioSelecionado === 'PagPixBank') carregarTransacoesPagPix()
             }"><v-icon>search</v-icon></v-btn>
           </v-flex>
          <v-flex shrink>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="editando = !editando"
                >
                  <v-list-tile-action>
                    <v-icon v-if="!editando">edit</v-icon>
                    <v-icon v-else>done</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Editar relatório</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="print()"
                >
                  <v-list-tile-action>
                    <v-icon>print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Imprimir relatório</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5 hide-display">
          <v-layout row>
            <h1> Relatório de vouchers</h1>
            <v-spacer></v-spacer>
            <span class="display-2">Total: {{ 0 | currency({ fractionCount: 2 }) }}</span>
          </v-layout>
          <hr/>
        </div>
        <v-data-table
          hide-actions
          :hide-headers="!cobrancas || !cobrancas.cobs.length"
          :loading="loading"
          :items="cobrancas.cobs"
          :pagination.sync="paginationCash"
          :total-items="totalItens"
          class="elevation-1"
          v-if="meioSelecionado === 'gerencianetpix'"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3" v-if="headersVisible.valor"><strong>{{props.item.valor.original | currency({ fractionCount: 2}) }}</strong></td>
              <td class="text-xs-left" v-if="headersVisible.data">
                <template v-if="props.item.calendario.criacao">
                  {{ dataAtualFormatada(props.item.calendario.criacao) }}
                </template>
              </td>
              <td class="text-xs-center px-0 hide-print" style="width: 0" v-if="headersVisible.status">
                <v-tooltip v-if="props.item.status === 'CONCLUIDA'" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">done_all</v-icon>
                  </template>
                  <span>Consumido</span>
                </v-tooltip>
                <v-tooltip v-else-if="props.item.status === 'ATIVA'" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="info">access_alarms</v-icon>
                  </template>
                  <span>Aguardando consumo</span>
                </v-tooltip>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="red">close</v-icon>
                  </template>
                  <span>Cancelado</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-left" v-if="headersVisible.valor">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor
              </th>
              <th class="text-xs-left" v-if="headersVisible.data">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Data
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.status">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.status = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
        </v-data-table>

        <v-data-table
          hide-actions
          :hide-headers="transacoesPagPix.length == 0"
          :loading="loading"
          :items="transacoesPagPix"
          :total-items="transacoesPagPix.length"
          class="elevation-1"
          v-else
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3" v-if="headersVisible.id"><strong>{{props.item.id}}</strong></td>
              <td class="text-xs-left px-3" v-if="headersVisible.valor"><strong>{{props.item.valor | currency({ fractionCount: 2}) }}</strong></td>
              <td class="text-xs-left px-3" v-if="headersVisible.status"><strong>{{props.item.status }}</strong></td>
              <td class="text-xs-left" v-if="headersVisible.data">
                <template v-if="props.item.dataHoraCriacao">
                  {{ dataAtualFormatada(props.item.dataHoraCriacao) }}
                </template>
              </td>
              <td class="text-xs-center px-0 hide-print" style="width: 0" v-if="headersVisible.status">
                <v-tooltip v-if="props.item.status === 'Concluída'" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">done_all</v-icon>
                  </template>
                  <span>Consumido</span>
                </v-tooltip>
                <v-tooltip v-else-if="props.item.status === 'Aberta'" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="info">access_alarms</v-icon>
                  </template>
                  <span>Aguardando consumo</span>
                </v-tooltip>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="red">close</v-icon>
                  </template>
                  <span>Cancelado</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-left" v-if="headersVisible.id">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.id = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                ID
              </th>
              <th class="text-xs-left" v-if="headersVisible.valor">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor
              </th>
              <th class="text-xs-left" v-if="headersVisible.status">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Status
              </th>
              <th class="text-xs-left" v-if="headersVisible.data">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Data
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.status">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.status = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
        </v-data-table>

        <div class="text-xs-center" v-if="meioSelecionado === 'gerencianetpix'">
          <v-pagination v-model="paginationCash.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="cobrancas && cobrancas.cobs.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Total: {{ total_relatorio_cash | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
    </template>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      cobrancas: { cobs: [], parametros: { paginacao: { quantidadeTotalDeItens: 0 } } },
      transacoesPagPix: [],
      valid: false,
      editando: false,
      menuDataInicial: false,
      date: moment().format(`YYYY-MM-DD`),
      month: null,
      dates: [],
      filtroCPF: '',
      filtro: 'CONCLUIDA',
      filtros: [
        {
          title: 'Consumidos',
          value: 'CONCLUIDA'
        },
        {
          title: 'Aguardando consumo',
          value: 'ATIVA'
        }
      ],
      headersVisible: {
        valor: true,
        data: true,
        cliente: false,
        status: true,
        id: true
      },
      today: null,
      selectOpcoes: 'dia',
      options: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'custom'
        }
      ],
      opcoes: {
        dia: true,
        custom: false,
        mes: false,
        recebidos: false,
        data_relatorio: moment().format(`DD/MM/YYYY`),
        mes_relatorio: null,
        intervalo_relatorio: []
      },
      rules: {
        cpf: value => {
          const pattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
          return !value || pattern.test(value) || 'CPF inválido.'
        }
      },
      paginationCash: {
        page: 1,
        rowsPerPage: 10
      },
      totalItens: 0,
      total_relatorio_cash: 0,
      meioSelecionado: undefined
    }
  },
  computed: {
    pages () {
      let count = this.cobrancas.parametros.paginacao.quantidadeTotalDeItens
      if (this.paginationCash.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.paginationCash.rowsPerPage)
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    pagamentosSecundarios () {
      return this.$store.getters.pagamentosSecundarios
    }
  },
  watch: {
    paginationCash: {
      handler (val, oldval) {
        this.carregarRelatorio()
      },
      deep: true
    },
    posto (val) {
      if (val) {
        this.carregarPagamentosSecundarios()
        if (this.meioSelecionado) {
          if (this.meioSelecionado.toLowerCase() === 'gerencianetpix') this.carregarRelatorio()
          else if (this.meioSelecionado.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
        }
      }
    },
    date (val) {
      if (val) {
        this.opcoes.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.opcoes.dia = true
      } else if (val === 'custom') {
        this.opcoes.custom = true
      } else if (val === 'mes') {
        this.opcoes.mes = true
      }
    },
    meioSelecionado (val) {
      if (val && val.toLowerCase() === 'gerencianetpix') {
        this.carregarRelatorio()
      } else if (val && val.toLowerCase() === 'pagpixbank') {
        this.carregarTransacoesPagPix()
      }
    }
  },
  mounted () {
    this.today = new Date().setHours(0, 0, 0, 0)
    if (this.posto) this.carregarPagamentosSecundarios()
    if (this.posto && this.meioSelecionado) {
      if (this.meioSelecionado.toLowerCase() === 'gerencianetpix') this.carregarRelatorio()
      else if (this.meioSelecionado.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
    }
  },
  methods: {
    print () {
      window.print()
    },
    formatDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    limparOpcoes () {
      this.opcoes.dia = false
      this.opcoes.custom = false
      this.opcoes.mes = false
    },
    carregarRelatorio () {
      let tempOpcoes = {
        run: true
      }
      tempOpcoes['status'] = this.filtro
      if (this.filtro) {
        if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
          tempOpcoes['data_inicio'] = this.opcoes.intervalo_relatorio[0].split('/').reverse().join('-')
          tempOpcoes['data_fim'] = this.opcoes.intervalo_relatorio[1].split('/').reverse().join('-')
        } else if (this.opcoes.dia && this.date) {
          tempOpcoes['data_inicio'] = this.date
          tempOpcoes['data_fim'] = this.date
        } else if (this.opcoes.mes && this.month) {
          const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
          const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)
          tempOpcoes['data_inicio'] = initialDate.toISOString().substr(0, 10)
          tempOpcoes['data_fim'] = finalDate.toISOString().substr(0, 10)
        }
      }
      this.$store.dispatch('relatorioPix', { filtro: tempOpcoes, pagination: this.paginationCash }).then(value => {
        this.cobrancas = value
        this.totalItens = value.parametros.paginacao.quantidadeTotalDeItens
      })
    },
    dataSelecionada () {
      if (this.opcoes.custom) {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.opcoes.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    },
    dataAtualFormatada (dataCobranca) {
      let data = new Date(dataCobranca)
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      return dia + '/' + mes + '/' + ano
    },
    carregarPagamentosSecundarios () {
      this.$store.dispatch('carregarPagamentosSecundarios').then(json => {
        if (json.length > 0) {
          this.meioSelecionado = json[0].forma_pagamento.descricao
        }
      })
    },
    carregarTransacoesPagPix () {
      const data = {
        method: 'GET',
        cnpj_posto: this.posto.cnpj,
        // data_inicial: this.new_date,
        // data_final: this.new_date,
        tipo_transacao: 'imediata'
      }

      if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
        data['data_inicial'] = this.opcoes.intervalo_relatorio[0].split('/').reverse().join('-')
        data['data_final'] = this.opcoes.intervalo_relatorio[1].split('/').reverse().join('-')
      } else if (this.opcoes.dia && this.date) {
        data['data_inicial'] = this.date
        data['data_final'] = this.date
      } else if (this.opcoes.mes && this.month) {
        const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
        const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)
        data['data_inicial'] = initialDate.toISOString().substr(0, 10)
        data['data_final'] = finalDate.toISOString().substr(0, 10)
      }

      this.$store.dispatch('transacoesPagPixBank', data).then(json => {
        this.transacoesPagPix = json
      })
    }
  }
}
</script>
